<template>
  <div class="messages-page">

    <!-- Page header -->
    <div class="page-header">
      <button class="back-btn" onclick="window.history.back()"><i class="ft-arrow-left"></i></button>
      <div class="header-info">
        <span class="page-title">Messages</span>
        <span class="page-subtitle" v-if="messages.length > 0">{{ messages.length }} message{{ messages.length !== 1 ? 's' : '' }}</span>
        <span class="page-subtitle" v-else>No new messages</span>
      </div>
    </div>

    <!-- Loading -->
    <div class="loading-state" v-if="loading">
      <div class="spinner"></div>
      <span>Loading messages…</span>
    </div>

    <!-- Empty state -->
    <div class="empty-state" v-if="!loading && messages.length === 0">
      <div class="empty-icon-wrap">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
          <polyline points="22,6 12,13 2,6"/>
        </svg>
      </div>
      <p class="empty-title">All caught up</p>
      <p class="empty-sub">You have no messages at this time.</p>
    </div>

    <!-- Message list -->
    <div class="section-pad" v-if="!loading && messages.length > 0">
      <div class="message-card" v-for="message in messages" v-bind:key="message.id">
        <div class="message-accent"></div>
        <div class="message-body">
          <div class="message-top">
            <div class="message-avatar">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                <polyline points="22,6 12,13 2,6"/>
              </svg>
            </div>
            <div class="message-meta">
              <span class="message-title">{{ message.copy }}</span>
              <span class="message-date">
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
                </svg>
                {{ formatDate(message.createdate) }}
              </span>
            </div>
          </div>
          <p class="message-content" v-if="message.title">{{ message.title }}</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import moment from 'moment'
import swal from 'sweetalert'

export default {
  name: 'messages',
  data: function () {
    return {
      messages: [],
      loading: true
    }
  },
  mounted: function () {
    this.$store.commit('SET_LAYOUT', 'AppLayout')
    var that = this

    $.ajax({
      beforeSend: function (xhr) {
        xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
      },
      url: 'https://admin.medicater.co.za/api/basic/get_messages',
      type: 'post',
      data: { push_token: localStorage.getItem('push_token') },
      success: function (data) {
        that.loading = false
        if (data.data && data.data.messages) {
          that.messages = data.data.messages
        }
      },
      error: function (data) {
        that.loading = false
        if (window.localStorage.getItem(this.url)) {
          var offlineData = JSON.parse(window.localStorage.getItem(this.url))
          this.success(offlineData)
        } else {
          swal({ text: 'Please connect to the internet', icon: 'info', button: 'Ok' })
        }
      }
    })
  },
  methods: {
    formatDate: function (dateStr) {
      if (!dateStr) return ''
      var m = moment(dateStr)
      if (m.isSame(moment(), 'day')) return 'Today, ' + m.format('h:mm A')
      if (m.isSame(moment().subtract(1, 'days'), 'day')) return 'Yesterday, ' + m.format('h:mm A')
      return m.format('DD MMM YYYY')
    }
  }
}
</script>

<style scoped>
.messages-page {
  min-height: 100vh;
  background: #f0f4f8;
  padding-bottom: 40px;
}

/* ── Page header ── */
.page-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 30px 20px 20px;
  background: linear-gradient(135deg, #1a587b 0%, #0f3d5c 100%);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10;
  margin-top: 3.2rem;
  border-radius: 0;
  box-shadow: 0 8px 32px rgba(15, 61, 92, 0.35);
}

.back-btn {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s;
}
.back-btn:hover { background: rgba(255, 255, 255, 0.25); }

.header-info { display: flex; flex-direction: column; gap: 3px; min-width: 0; }

.page-title {
  font-size: 1.05rem;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.2px;
}

.page-subtitle {
  font-size: 0.73rem;
  color: rgba(255, 255, 255, 0.65);
  font-weight: 500;
}

/* ── Section ── */
.section-pad {
  padding: 110px 16px 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* ── Loading ── */
.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  padding: 120px 16px 40px;
  color: #94a3b8;
  font-size: 0.875rem;
  font-weight: 500;
}

.spinner {
  position: relative;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: 3px solid transparent;
  border-top-color: #1a587b;
  border-left-color: #1a587b;
  animation: spin 0.9s cubic-bezier(0.45, 0.05, 0.55, 0.95) infinite;
}
.spinner::after {
  content: '';
  position: absolute;
  inset: 5px;
  border-radius: 50%;
  border: 2.5px solid transparent;
  border-top-color: rgba(26, 88, 123, 0.35);
  border-left-color: rgba(26, 88, 123, 0.35);
  animation: spin 1.8s cubic-bezier(0.45, 0.05, 0.55, 0.95) infinite reverse;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* ── Empty state ── */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 120px 32px 40px;
  text-align: center;
}

.empty-icon-wrap {
  width: 72px;
  height: 72px;
  border-radius: 20px;
  background: #e0f2fe;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1a587b;
  margin-bottom: 4px;
}

.empty-title {
  font-size: 1rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.empty-sub {
  font-size: 0.85rem;
  color: #94a3b8;
  margin: 0;
}

/* ── Message card ── */
.message-card {
  display: flex;
  background: #fff;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.07);
  border: 1px solid #e8edf2;
  transition: box-shadow 0.2s, transform 0.15s;
}
.message-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
}

.message-accent {
  width: 4px;
  flex-shrink: 0;
  background: linear-gradient(180deg, #1a587b 0%, #0f3d5c 100%);
}

.message-body {
  padding: 16px;
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.message-top {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.message-avatar {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: linear-gradient(135deg, #e0f2fe, #bae6fd);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1a587b;
  flex-shrink: 0;
}

.message-meta {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  flex: 1;
}

.message-title {
  font-size: 0.9rem;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.35;
}

.message-date {
  font-size: 0.7rem;
  color: #94a3b8;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
}

.message-content {
  font-size: 0.85rem;
  color: #475569;
  line-height: 1.55;
  margin: 0;
  padding-left: 48px;
}
</style>
